import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconArrow: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M481.834667 353.834667a42.666667 42.666667 0 0 1 60.330666 0l256 256a42.666667 42.666667 0 0 1-60.330666 60.330666L512 444.330667l-225.834667 225.834666a42.666667 42.666667 0 0 1-60.330666-60.330666l256-256z"
    />
);